import { Star } from "lucide-react";

export default function SocialIcons({ size = 18, className = "", testIdPrefix = "social", showRating = true }) {
    const facebookUrl = "https://www.facebook.com/flowlux.co";
    const googleReviewsUrl =
        "https://www.google.com/search?q=flowlux&rlz=1C1HKFL_enUS1213US1213&oq=flowlux+&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIICAEQRRgnGDsyCAgCEEUYJxg7MggIAxAAGAoYHjIGCAQQABgeMgYIBRBFGDwyBggGEEUYPTIGCAcQRRg80gEHOTI4ajBqN6gCALACAA&sourceid=chrome&ie=UTF-8";
    const dim = size;

    return (
        <div className={`inline-flex items-center gap-2 ${className}`}>
            {/* Facebook */}
            <a
                href={facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="FlowLux on Facebook"
                data-testid={`${testIdPrefix}-facebook`}
                className="inline-flex items-center justify-center rounded-full border border-flow-line bg-white hover:bg-flow-soft transition-colors"
                style={{ width: dim + 14, height: dim + 14 }}
            >
                <svg width={dim} height={dim} viewBox="0 0 24 24" fill="#1877F2" aria-hidden="true">
                    <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.13 8.44 9.94v-7.03H7.9v-2.91h2.54V9.84c0-2.51 1.49-3.9 3.77-3.9 1.09 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.78-1.63 1.57v1.88h2.78l-.44 2.91h-2.34V22c4.78-.81 8.44-4.94 8.44-9.94z" />
                </svg>
            </a>

            {/* 5-star + 250+ pill */}
            {showRating && (
            <a
                href={googleReviewsUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="250+ five-star reviews — FlowLux"
                data-testid={`${testIdPrefix}-reviews`}
                className="inline-flex items-center gap-1.5 px-2.5 rounded-full border border-flow-line bg-white hover:bg-flow-soft transition-colors"
                style={{ height: dim + 14 }}
            >
                <span className="flex items-center gap-[1px]">
                    {[0, 1, 2, 3, 4].map((i) => (
                        <Star key={i} size={11} className="text-[#FBBC05]" fill="#FBBC05" strokeWidth={0} />
                    ))}
                </span>
                <span className="text-[11px] tracking-[0.06em] text-flow-ink leading-none whitespace-nowrap" style={{ fontWeight: 500 }}>
                    250+
                </span>
            </a>
            )}
        </div>
    );
}
